/**
 * ServicesStatusStrip — Feb 2026 launch KYC was retired platform-wide.
 * ComplianceShortcut (the KYC-focused deep-link banner that used to render
 * above the tabs) was deleted in the same sweep — only the payments-mode
 * indicator survives, and it's now clickable so an admin can jump straight
 * to the Institutional Upgrades tab to verify a pending bank transfer.
 */
import { Link } from "react-router-dom";

export function ServicesStatusStrip({ services }) {
    if (!services) return null;
    // We only render the payments pill now. Email / SMS / IPRS are all
    // retired (in-portal comms, no KYC), so surfacing them as "disabled"
    // chips just added noise.
    const paymentsMode = (services.modes || {}).payments || "bank_transfer";
    return (
        <div className="mb-6 border border-border rounded p-3 bg-card flex flex-wrap items-center gap-3 text-xs">
            <span className="overline">Integrations</span>
            <Link
                to="/admin#institutional-upgrades"
                data-testid="service-mode-payments"
                className="px-2 py-1 rounded border font-mono border-success text-success bg-success/10 hover:bg-success/20 transition-colors"
                onClick={(e) => {
                    // Prevent hash from being stripped — open the Institutional
                    // Upgrades tab directly by dispatching a jump event.
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("md-admin-open-tab", { detail: "subscription-requests" }));
                }}
                title="Open Institutional Upgrades to verify a bank transfer"
            >
                PAYMENTS: BANK TRANSFER · click to verify
            </Link>
            <span className="text-muted-foreground ml-auto">
                All comms in-portal. Payments: manual bank transfer + admin verify.
            </span>
        </div>
    );
}
